import LayoutBasic from '@/layouts/basic'

const meta = {
  auth: true,
}

const pre = 'country-'

export default {
  path: '/country',
  name: 'country',
  redirect: {
    name: `${pre}list`,
  },
  meta,
  component: LayoutBasic,
  children: [
    {
      path: 'list',
      name: `${pre}list`,
      meta: {
        ...meta,
        title: '国家管理',
      },
      component: () => import('@/views/country/list'),
    },
  ],
}
